"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProposalEditorOnPage = exports.EDIT_BOX_COULD_NOT_OPEN_MESSAGE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useEditBoxSyncing = require("../../hooks/use-edit-box-syncing");
var _editorButtons = require("../chat/proposal-edit/editor-buttons");
var _ProposalEditor = require("../chat/proposal-edit/ProposalEditor");
var _SectionBoundary = require("../SectionBoundary");
var _EditBoxReviewPreview = require("./EditBoxReviewPreview");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EDIT_BOX_COULD_NOT_OPEN_MESSAGE = exports.EDIT_BOX_COULD_NOT_OPEN_MESSAGE = "The edit box could not open. The card is unchanged.";
var ProposalEditorSyncedWithDocument = function ProposalEditorSyncedWithDocument(props) {
  var syncing = (0, _useEditBoxSyncing.useEditBoxSyncing)((0, _ProposalEditor.bookmarksTheEditBoxReads)(props.textRedline, props.textRedlineBeforeEdit));
  var textRedline = props.textRedline,
    textRedlineBeforeEdit = props.textRedlineBeforeEdit,
    author = props.author;
  var renderReview = (0, _react.useCallback)(function (review) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditBoxReviewPreview.EditBoxReviewPreview, {
      textRedlineProposed: textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedline,
      author: author,
      review: review
    });
  }, [textRedline, textRedlineBeforeEdit, author]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalEditor.ProposalEditor, _objectSpread(_objectSpread({}, props), {}, {
    syncing: syncing,
    renderReview: renderReview,
    "data-sentry-element": "ProposalEditor",
    "data-sentry-component": "ProposalEditorSyncedWithDocument",
    "data-sentry-source-file": "ProposalEditorOnPage.tsx"
  }));
};
var EditBoxCouldNotOpen = function EditBoxCouldNotOpen(_ref) {
  var onCancel = _ref.onCancel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "alert",
    className: "flex flex-col items-start gap-2 text-[11px] text-[#686766]",
    "data-sentry-component": "EditBoxCouldNotOpen",
    "data-sentry-source-file": "ProposalEditorOnPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: EDIT_BOX_COULD_NOT_OPEN_MESSAGE
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: _editorButtons.SECONDARY_BUTTON_CLASS,
      onClick: onCancel,
      children: _editorButtons.CANCEL_BUTTON_LABEL
    })]
  });
};
var ProposalEditorOnPage = exports.ProposalEditorOnPage = function ProposalEditorOnPage(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
    section: "edit_box",
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(EditBoxCouldNotOpen, {
      onCancel: props.onCancel
    }),
    "data-sentry-element": "SectionBoundary",
    "data-sentry-component": "ProposalEditorOnPage",
    "data-sentry-source-file": "ProposalEditorOnPage.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProposalEditorSyncedWithDocument, _objectSpread(_objectSpread({}, props), {}, {
      "data-sentry-element": "ProposalEditorSyncedWithDocument",
      "data-sentry-source-file": "ProposalEditorOnPage.tsx"
    }))
  });
};